/* 🤖 this file was generated by svg-to-ts */
export const iconFdusd: {
  name: 'fdusd';
  data: string;
} = {
  name: 'fdusd',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="currentColor" d="M16 0C7.16 0 0 7.16 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0m1.92 24.34H8.63v-4.28h9.29zm5.46-12.83h-5.45v2.35h5.45v3.84h-9.29V7.66h9.29z"/></svg>`,
};
